import { Bubble } from './Bubble'

import React from 'react'

import { StreamingNote } from '@/types/unlock'

interface Replies {
  messages: StreamingNote[]
  isRepliesOpen: boolean
  setIsRepliesOpen: (isRepliesOpen: boolean) => void
  setShowComposer?: (showComposer: boolean) => void
  showComposer?: () => void
}

export function Replies({ messages, isRepliesOpen, setShowComposer, showComposer }: Replies) {
  return (
    <>
      {/* Reactions could go here... */}

      {isRepliesOpen && (
        <div className='relative ml-6 pt-2'>
          <ul className='mb-3 flex flex-col gap-2'>
            {messages?.map((message, index) => (
              <Bubble
                key={message.uuid}
                message={message}
                setShowComposer={setShowComposer}
                showComposer={showComposer}
                isReply
                isLastIndex={index === messages.length - 1}
              />
            ))}
          </ul>
        </div>
      )}
    </>
  )
}
